import { AUTH } from '../config/app-config';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';


let client;

export function getOidcClient() {
  if (!AUTH?.enabled) return null;
  if (client) return client;

  client = new UserManager({
    authority: AUTH.authority,
    client_id: AUTH.clientId,
    response_type: 'code',
    scope: AUTH.scope,
    redirect_uri: `${window.location.origin}/auth/callback`,
    post_logout_redirect_uri: `${window.location.origin}/auth/logged-out`,
    silent_redirect_uri: `${window.location.origin}/auth/silent-renew.html`,
    automaticSilentRenew: true,
    metadata: AUTH.metadata,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
    filterProtocolClaims: true,
    loadUserInfo: true,
  });

  return client;
}
